import React from "react";
import { Badge } from "flowbite-react";
import { BannerRotation } from "@/components/ads/BannerRotation";
import type { AdBook, SlotBanner } from "@/domains/ads/AdConfig";

export interface BannerAdProps {
  banners: readonly SlotBanner[];
  books?: readonly AdBook[];
}

/**
 * サイドバーなど、狭い列に単独で置く広告のカード
 */
export const BannerAd: React.FC<BannerAdProps> = ({ banners, books = [] }) => {
  if (banners.length === 0 && books.length === 0) {
    return null;
  }

  return (
    <section
      aria-label="広告"
      className="rounded-2xl border border-primary-100 bg-white p-3 shadow-sm"
    >
      <Badge color="gray" size="xs" className="w-fit">
        PR
      </Badge>
      <div className="mt-2 flex justify-center">
        <BannerRotation banners={banners} books={books} />
      </div>
    </section>
  );
};
